import * as React from 'react';

import { Kbd, Row, TouchButton } from '@rematter/ui-web';
import { LucideArrowLeftToLine } from 'lucide-react';

interface GoBackButtonProps {
  onGoBack: () => void;
  isDisabled?: boolean;
}

export const GoBackButton: React.FC<GoBackButtonProps> = ({
  onGoBack,
  isDisabled,
}) => (
  <TouchButton
    variant="outline"
    color="neutral"
    className="@GoBackButton h-13 w-25"
    onPress={onGoBack}
    isDisabled={isDisabled}
  >
    <Row gap1>
      <Kbd variant="outline" shortcut="Meta+Escape" />
      <LucideArrowLeftToLine />
    </Row>
  </TouchButton>
);
